import { createRouter, createWebHashHistory } from 'vue-router'
import HouseLight from './views/wechat/HouseLight.vue'
import WindowShadow from './views/wechat/WindowShadow.vue'
import HouseLightResidential from './views/sunlight/HouseLightResidential.vue'
import BuildingDistance from './views/distance/BuildingDistance.vue'
import Residential from './views/building/Residential.vue'
import fieldView from './views/fieldView/fieldView.vue'
import noiseView from './views/noise/NoiseAnalysis.vue'
import HouseResourcesView from './views/houseResources/HouseResources.vue'
import HouseTypeView from './views/houseType/HouseType.vue'

const routes = [
  {
    path: '/residential/:code',
    name: 'building',
    component: Residential
  },
  {
    path: '/residential/sunshine/:code',
    name: 'sunshine',
    component: HouseLightResidential
  },
  {
    path: '/house',
    name: 'HouseLight',
    component: HouseLight
  },
  {
    path: '/window',
    name: 'WindowShadow',
    component: WindowShadow
  },
  {
    path: '/residential/distance/:code',
    name: 'Distance',
    component: BuildingDistance
  },
  {
    path: '/residential/field/:code',
    name: 'fieldView',
    component: fieldView
  },
  {
    path: '/residential/noise/:code',
    name: 'noise',
    component: noiseView
  },
  {
    path: '/residential/houseSources/:code',
    name: 'houseSources',
    component: HouseResourcesView
  },
  {
    path: '/residential/houseType/:code',
    name: 'houseType',
    component: HouseTypeView
  }
]
 
const router = createRouter({
  history: createWebHashHistory(),
  routes
})
 
export default router
